import { Record } from 'immutable';

const VocabularyResultRecord = Record({
  studentId: undefined,
  totalWords: undefined,
  completedWords: undefined,
  completedRatio: undefined,
});

class VocabularyResult extends VocabularyResultRecord {}

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'studentId':
      return [key, `${item}`];
    case 'totalWords':
    case 'completedWords':
      return [key, Number.parseInt(item, 10)];
    default:
      return [key, item];
  }
};

VocabularyResult.create = (data) => new VocabularyResult(data).mapEntries(reviver);

export default VocabularyResult;



// WEBPACK FOOTER //
// ./data/Vocabulary/VocabularyResult/model.js